<form [formGroup]="form">
  <app-input [type]="field.type === fieldType.text ? 'text' : 'number'" [control]="getFormCtrl()"
    (onSubmit)="emitValue($event)">
  </app-input>
  <app-form-error [form]="form" [controlName]="'control'" *ngIf="isRequiredField()"></app-form-error>
</form>
